'use client'
import { dynamicEvents } from '../../../../events/dynamicEvents.js';
import { getProjectSettings } from '../../../../store/state/projectSettings/projectSettings.js';
import { convertSdkUserToUserProfile } from '../convertSdkUserToUserProfile/convertSdkUserToUserProfile.js';

const hasFieldChanged = (fields, record1, record2) => {
    if (!record1 || !record2)
        return false;
    for (const name of fields) {
        const oldValue = record1[name];
        const newValue = record2[name];
        if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
            return true;
        }
    }
    return false;
};
const raiseUserProfileEvent = ({ oldUser, newUser, }) => {
    var _a, _b;
    const settings = getProjectSettings();
    if (!settings)
        return;
    const hasKycChanged = hasFieldChanged(settings.kyc.map(({ name }) => name), oldUser, newUser);
    const hasCustomFieldsChanged = hasFieldChanged((_b = (_a = settings.customFields) === null || _a === void 0 ? void 0 : _a.map(({ name }) => name)) !== null && _b !== void 0 ? _b : [], oldUser.metadata, newUser.metadata);
    if (!hasKycChanged && !hasCustomFieldsChanged)
        return;
    dynamicEvents.emit('userProfileUpdated', convertSdkUserToUserProfile(newUser));
};

export { hasFieldChanged, raiseUserProfileEvent };
